<!-- 库房列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <storageRoomAction ref="storageRoomAction" v-if="showStatus" @drawerCancel="drawerCancel" @toDetail="toDetail"
                :actionData="actionData"></storageRoomAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="formList.storageRoomList.length > 0" :searchList="formList.storageRoomList"
                    :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum"
                border style="width: 100%" highlight-current-row>
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="stName" label="库房名称" min-width="120">
                </el-table-column>
                <el-table-column align="center" prop="stCode" label="库房编号" min-width="120">
                </el-table-column>
                <el-table-column align="center" prop="stAddress" label="库房地址" min-width="120">
                </el-table-column>
                <el-table-column align="center" prop="stType" label="仓库类型" min-width="120">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.stType == 0">整件拣货</el-tag>
                        <el-tag size="mini" v-if="scope.row.stType == 1">拆零拣货</el-tag>
                        <el-tag size="mini" v-if="scope.row.stType == 2">整零合一</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="ormName" label="归属组织" min-width="150">
                </el-table-column>
                <el-table-column align="center" prop="stState" label="库房状态" min-width="100">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.stState == 1">启用</el-tag>
                        <el-tag size="mini" v-if="scope.row.stState == 0">停用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="isStore" label="是否门店库房" min-width="120">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.isStore == 1">是</el-tag>
                        <el-tag size="mini" v-if="scope.row.isStore == 0">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="isAutoCuring" label="是否自动养护" min-width="120">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.isAutoCuring == 1">是</el-tag>
                        <el-tag size="mini" v-if="scope.row.isAutoCuring == 0">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="stIsputin" label="是否可入库" min-width="120">
                    <template slot-scope="scope">
                        {{ scope.row.stIsputin == 0 ? '不可入库' : '可以入库' }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="stIsgetout" label="是否可出库" min-width="120">
                    <template slot-scope="scope">
                        {{ scope.row.stIsgetout == 0 ? '不可出库' : '可以出库' }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="stIsgetout" label="是否备货库房" min-width="120">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.isStockUp == 1">是</el-tag>
                        <el-tag size="mini" v-if="scope.row.isStockUp == 0">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="stIsgetout" label="是否WMS" min-width="120">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.isWms == 1">是</el-tag>
                        <el-tag size="mini" v-if="scope.row.isWms == 0">否</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import formList from './otherData.js'
import storageRoomAction from "@/components/storageRoomAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        storageRoomAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            showStatus: false,
            actionData: {},
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            buttonList: [],
            getRequestData: {
                stName: '',
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                page: 1,
                rows: 30,
            },
            returnData: {
                pages: 0,  // 总页数
                total: 0,  // 总条数
                pageNum: 0,  // 当前页数
                list: []
            },
            selectedDataIndex: 0,
            formList: formList,

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        openSearch() { },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false
            commitData && this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 修改状态
        async setDataAction() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: '暂无数据',
                        type: 'error'
                    });
                    return false
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: '请先选择您要操作的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            var sendData = {
                ids: [dataInfo.stId]
            }
            let responseData = await this.$http.setStorageRoomStatus(sendData)
            if (responseData.status == 200) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }

        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: [],
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: '',
                        type: ''
                    }
                    break;
                case 1:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: '暂无数据',
                                type: 'error'
                            });
                            return false
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: '请先选择您要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: [],
                        oldData: dataInfo,
                        orderId: '',
                        printSouce: '',
                        printJurId: '',
                        type: ''
                    }
                    break;
                case 2:
                    this.delDataAction()
                    break;
                case 3:
                    this.setDataAction()
                    break;
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },


        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: '暂无数据',
                        type: 'error'
                    });
                    return false
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: '请先选择您要操作的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.stId]
                }
                let responseData = await this.$http.delStorageRoom(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });

        },

        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getStorageRoom(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum

                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        var objs = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        for (const key in objs) {
            this.$set(this.getRequestData, key, objs[key])
        }
        this.getDataList()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped></style>
